import React from "react";
import { useNavigate } from "react-router-dom";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CommonButton } from "../button/Button";
import { useTranslation } from "react-i18next";
const BranchDataSavedModal = ({ handleClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div>
      <div className="d-flex justify-content-between pb-5">
        <h3>{t("successfully-saved")}</h3>
        <FontAwesomeIcon
          icon={faTimes}
          size="12px"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <p>{t("successfully-saved-text-1")}</p>
      <p>{t("successfully-saved-text-2")}</p>
      <div className="d-flex justify-content-end pt-5">
        <CommonButton
          click={handleClose}
          title={t("cancel")}
          borderRadius="5px"
          bgColor="#ffff"
          color="#000"
          margin="0 10px 0 0"
          hoverBgColor="#ffff"
        />
        <CommonButton
          click={() => navigate("/user-management")}
          title="GO TO USER MANAGEMENT"
          border="none"
          borderRadius="5px"
        />
      </div>
    </div>
  );
};

export default BranchDataSavedModal;
